import { render, staticRenderFns } from "./ym-farming.vue?vue&type=template&id=3ebb3fe2&scoped=true&"
import script from "./ym-farming.vue?vue&type=script&lang=js&"
export * from "./ym-farming.vue?vue&type=script&lang=js&"
import style0 from "./ym-farming.vue?vue&type=style&index=0&id=3ebb3fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb3fe2",
  null
  
)

export default component.exports